<template>
	<div @click="onClick" class="width-100 display-flex flex-column listing-card-container">
		<div class="width-100 display-flex flex-row flex-justify-space-between mb-5">
			<div class="integration-info-container display-flex flex-row flex-align-center pl-5">
				<SIcon :name="isAddOn ? 'button-installation' : 'tool-installation'" width="12" height="17" />
				<div class="feature-type-description mx-2">
					{{ isAddOn ? 'Button add-on in' : 'Tool' }}
				</div>
				<SIcon v-if="featureContextServiceSlug" :name="featureContextServiceSlug" width="20" height="20" />
				<template v-if="relatedIntegrationsSlugs?.length > 0">
					<div class="divider ml-2" />
					<SIcon v-for="slug in relatedIntegrationsSlugs" :key="slug" :name="slug" width="20" height="20" class="ml-2" />
				</template>
			</div>
			<AnemicButton class="install-button">Get</AnemicButton>
		</div>
		<div class="width-100 px-5">
			<div class="feature-title">{{ listing.title }}</div>
			<div class="description-text">
				{{ listing.description }}
			</div>
		</div>
	</div>
</template>
<script>
import { FlowType } from '@ply-io/ply-front-shared-utilities';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'MarketplaceListingCard',
	props: {
		listing: { type: Object },
	},
	computed: {
		isAddOn() {
			return this.listing.workflow_type === FlowType.Experience;
		},
		featureContextServiceSlug() {
			return this.listing?.feature_context_service?.service_slug;
		},
		relatedIntegrationsSlugs() {
			return this.listing?.integrations
				.map((integration) => integration.service_slug)
				.filter((slug) => slug !== this.featureContextServiceSlug);
		},
	},
	methods: {
		onClick() {
			AppDialogManagerService.openListingDetailsDialog({ listing: this.listing });
		},
	},
	data() {
		return {};
	},
};
</script>
<style lang="scss" scoped>
.listing-card-container {
	height: 130px;
	cursor: pointer;
	overflow: hidden;
	max-width: 755px;
	min-width: 340px;
	transition: 0.3s;
	border-radius: 10px;
	border: 1px solid #dfdfe2;
	background: var(--bg-color);
	&:active {
		background: #f9fafc;
	}
	&:active,
	&:hover {
		box-shadow: 0px 3px 6px #dbdfe6;
	}
}
.install-button {
	margin: 8px 10px 0 0;
	height: 30px !important;
	padding: 0px 20px !important;
	border-radius: 6px !important;
	background: white !important;
	border: 1px solid #5f60dc !important;

	font-size: 16px !important;
	color: #5f60dc !important;
	font-weight: normal !important;
	letter-spacing: 0.21px !important;
}
.feature-title {
	color: #444444;
	font-size: 16px;
	overflow: hidden;
	font-weight: medium;
	display: -webkit-box;
	-webkit-line-clamp: 2; // num of rows to break
	letter-spacing: 0.21px;
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
}
.description-text {
	font-size: 14px;
	color: #8f95aa;
	overflow: hidden;
	font-weight: normal;
	letter-spacing: 0px;
	display: -webkit-box;
	-webkit-line-clamp: 1; // num of rows to break
	-webkit-box-orient: vertical;
	text-overflow: ellipsis;
}
.integration-info-container {
	width: 100%;
	height: 35px;
	max-width: 250px;
	background: #f9fafc;
	border: 1px solid #f4f5f6;
	border-radius: 10px 0px 30px 0px;
}
.feature-type-description {
	font-size: 11px;
	color: #444444;
	letter-spacing: 0.14px;
}
.divider {
	width: 2px;
	height: 14px;
	background-color: #c1c4cf;
}
</style>
